import { render } from "./ViewOrder.vue?vue&type=template&id=785c634f&scoped=true&ts=true"
import script from "./ViewOrder.vue?vue&type=script&lang=ts"
export * from "./ViewOrder.vue?vue&type=script&lang=ts"

import "./ViewOrder.vue?vue&type=style&index=0&id=785c634f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785c634f"]])

export default __exports__